

export enum CBToolMode {
    Select,
    Draw,
    Erase,
    Rotate,
    Translate
}

export type SuperpixelData = {
    pixels: [number, number][]
    center: [number, number]
    meanRadius: number
}

export enum CBTextureType {
    Material,
    Mask,
    Lighting,
    Background,
    Superpixels
}

export class CBHistoryState {
    private readonly data:string;
    constructor(source:HTMLCanvasElement) {
        this.data = source.toDataURL("image/png")
        //console.log(`History is " ${Math.ceil(this.data.length / 1024)} kb`)
    }

    public restoreInto(source:HTMLCanvasElement, completed:()=>void) {
        const toCtx = source.getContext("2d");
        if (toCtx) {
            const img = new Image();
            img.addEventListener("load", function () {
                toCtx.drawImage(img, 0, 0);
                completed()
            });
            img.setAttribute("src", this.data);
        }
    }
}